import { Bar } from 'react-chartjs-2'
import { colorPalette } from '../../utils/color-utils'

export default function ChartMonth({ data, title, label }: any) {
    const labels = data.map((item: any) => item.month)

    const datasets = [
        {
            label: label,
            data: data.map((item: any) => item.sum),
            borderWidth: 2,
            datalabels: {
                color: colorPalette[0],
            },
        },
    ]

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
            },
            title: {
                display: true,
                text: title,
                font: {
                    size: 16,
                },
                padding: {
                    bottom: 24,
                },
            },
            datalabels: {
                display: true,
                color: 'black',
                font: {
                    size: 14,
                    weight: 'bold',
                },
                anchor: 'end',
                align: 'top',
            },
        },
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    } as any

    return (
        <Bar data={{ labels, datasets }} options={options} />
    )
}
